import { render, staticRenderFns } from "./stepFive.vue?vue&type=template&id=67e538f6&scoped=true&"
import script from "./stepFive.vue?vue&type=script&lang=ts&"
export * from "./stepFive.vue?vue&type=script&lang=ts&"
import style0 from "./stepFive.vue?vue&type=style&index=0&id=67e538f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e538f6",
  null
  
)

export default component.exports